import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { getTypographyRuleMixins, typographyMixin, TypographyProps } from '@clds/typography';

interface CustomProps {
  noWrap?: boolean;
}

export interface ScrollableLinesWrapContainerProps extends CustomProps {
  children: ReactNode;
  size?: TypographyProps['size'];
}

const maxHeightMixin = <Props extends TypographyProps & CustomProps>(props: Props) => {
  const typographyMixinValues = getTypographyRuleMixins(props.size, props.type);
  const multiplier = props.noWrap ? 1 : 2;
  return css`calc(${multiplier} * ${typographyMixinValues.lineHeight})`;
};

const Root = styled.div<TypographyProps>`
  margin: 0;
  max-height: ${maxHeightMixin};
  ${typographyMixin};

  word-break: break-all;
  overflow-y: auto;
  white-space: normal;

  > span {
    vertical-align: top;
  }
`;

const ScrollableLinesWrapContainer: FC<React.PropsWithChildren<ScrollableLinesWrapContainerProps>> = ({ children, size = 'sm', ...rest }) => {
  return (
    <Root type="regular" size={size} noWrap={rest?.noWrap} {...rest}>
      {children}
    </Root>
  );
};

export default ScrollableLinesWrapContainer;
